/**
 * Template types available in the system.
 * These correspond to the TemplateName column in the ModuleTemplateType database table.
 *
 * @remarks
 * - Backend performs case-insensitive lookup via ModuleTemplatesService.GetType(typeName)
 */
export enum TemplateTypeEnum {
  /** Templates for printable documents (PDF generation) */
  Printout = 'Printout',

  /** Templates for email correspondence */
  Correspondence = 'Correspondence',
}
